import React from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';
import type { ThemeColors } from '..';

export type ScreenShellProps = {
  colors: ThemeColors;
  children: React.ReactNode;
  style?: ViewStyle;
  contentStyle?: ViewStyle;
};

export function ScreenShell({ colors: _colors, children, style, contentStyle }: ScreenShellProps) {
  return (
    <View style={[styles.root, style]}>
      <View style={[styles.content, contentStyle]}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  content: {
    flex: 1,
  },
});
